import { getCommonStyle } from '../styleCommon';

export function getBorderStyles() {

	const commonAccentSecondary = getCommonStyle('color.accent.secondary');

	return {
		bottom: {
			color: null,
			lineDash: null,
			padding: null,
			width: null
		},
		default: {
			color: commonAccentSecondary,
			lineDash: '',
			padding: 0,
			width: 1
		},
		left: {
			color: null,
			lineDash: null,
			padding: null,
			width: null
		},
		right: {
			color: null,
			lineDash: null,
			padding: null,
			width: null
		},
		top: {
			color: null,
			lineDash: null,
			padding: null,
			width: null
		}
	};
}
